import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'forbidden-page',
    templateUrl: './forbidden.component.html',
    styleUrls: ['./forbidden.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ForbiddenComponent implements OnInit {
  constructor() {}

  ngOnInit() {
  }
}
